import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { LoginConfigResponse } from '../types/login-config.types';

@Injectable()
export class LoginConfigApiService {
  private readonly http = inject(HttpClient);

  loadConfig(): Observable<LoginConfigResponse> {
    return this.http.get<LoginConfigResponse>('/u/rest/login/config');
  }
}
